(() => {
  const VISIBLE_CLASS = 'lw-sticky-cta--visible';

  const init = (root) => {
    if (!root || root.dataset.lwStickyInit === 'true') return;
    root.dataset.lwStickyInit = 'true';

    const btn = root.querySelector('.lw-sticky-cta__btn');
    const href = btn ? btn.getAttribute('href') || '' : '';

    // Resolve the scroll target and the section that hosts it.
    let targetEl = null;
    if (href.startsWith('#') && href.length > 1) {
      try {
        targetEl = document.querySelector(href);
      } catch (err) {
        targetEl = null;
      }
    }

    // Smooth scroll (brand-tokens.css also sets scroll-behavior: smooth as a
    // native fallback; this keeps it working even if that rule is absent).
    if (btn && targetEl) {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    // In the theme editor, keep the button visible so it can be selected and edited.
    if (window.Shopify && window.Shopify.designMode) {
      root.classList.add(VISIBLE_CLASS);
      return;
    }

    // Collect blockers: the section the button scrolls to (featured product)
    // plus any additional sections configured via the "extra hide selectors"
    // setting (comma-separated CSS selectors).
    const blockers = [];
    const featuredEl = targetEl
      ? targetEl.closest('section') || targetEl
      : document.querySelector('.featured-product-lotus');
    if (featuredEl) blockers.push(featuredEl);

    // Skip elements pinned to the viewport (sticky/fixed) — they're always
    // intersecting, so using them as blockers would hide the CTA forever.
    // This makes headers / announcement bars automatically excluded when the
    // merchant has them set to sticky, and active blockers when they're static.
    const isPinned = (el) => {
      const pos = getComputedStyle(el).position;
      if (pos === 'fixed' || pos === 'sticky') return true;
      // Also walk up: a static section can sit inside a sticky group wrapper
      let p = el.parentElement;
      while (p && p !== document.body) {
        const pp = getComputedStyle(p).position;
        if (pp === 'fixed' || pp === 'sticky') return true;
        p = p.parentElement;
      }
      return false;
    };

    const extraRaw = root.dataset.lwExtraHideSelectors || '';
    if (extraRaw.trim()) {
      extraRaw.split(',').forEach((sel) => {
        const s = sel.trim();
        if (!s) return;
        try {
          document.querySelectorAll(s).forEach((el) => {
            if (!el || blockers.includes(el)) return;
            if (isPinned(el)) return;
            blockers.push(el);
          });
        } catch (err) {
          /* invalid selector — skip silently */
        }
      });
    }

    if (!blockers.length || !('IntersectionObserver' in window)) {
      root.classList.add(VISIBLE_CLASS);
      return;
    }

    const onScreen = new Set();
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            onScreen.add(entry.target);
          } else {
            onScreen.delete(entry.target);
          }
        });
        root.classList.toggle(VISIBLE_CLASS, onScreen.size === 0);
      },
      { threshold: 0 }
    );
    blockers.forEach((el) => io.observe(el));
  };

  const initAll = () => {
    document.querySelectorAll('[data-lw-sticky-cta]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: re-init when the section is (re)loaded.
  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target.querySelector('[data-lw-sticky-cta]');
    if (el) init(el);
  });
})();
